module.exports = __webpack_public_path__ + "img/check.97e2aa2d.svg";